export default "__VITE_ASSET__02b5be99__"